var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_475_1070)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.10937 15.0316H2.17187C1.98539 15.0316 1.80655 14.9575 1.67469 14.8257C1.54283 14.6938 1.46875 14.515 1.46875 14.3285V10.1097C1.46875 9.92326 1.54283 9.74442 1.67469 9.61256C1.80655 9.4807 1.98539 9.40662 2.17187 9.40662H3.10937C3.29585 9.40662 3.4747 9.4807 3.60656 9.61256C3.73842 9.74442 3.8125 9.92326 3.8125 10.1097V14.3285C3.8125 14.515 3.73842 14.6938 3.60656 14.8257C3.4747 14.9575 3.29585 15.0316 3.10937 15.0316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.67187 15.0308H8.73437C8.54789 15.0308 8.36905 14.9567 8.23719 14.8248C8.10533 14.693 8.03125 14.5141 8.03125 14.3276V7.29639C8.03125 7.10991 8.10533 6.93106 8.23719 6.7992C8.36905 6.66734 8.54789 6.59326 8.73437 6.59326H9.67187C9.85835 6.59326 10.0372 6.66734 10.1691 6.7992C10.3009 6.93106 10.375 7.10991 10.375 7.29639V14.3276C10.375 14.5141 10.3009 14.693 10.1691 14.8248C10.0372 14.9567 9.85835 15.0308 9.67187 15.0308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9531 15.0312H12.0156C11.8291 15.0312 11.6503 14.9572 11.5184 14.8253C11.3866 14.6934 11.3125 14.5146 11.3125 14.3281V4.01562C11.3125 3.82914 11.3866 3.6503 11.5184 3.51844C11.6503 3.38658 11.8291 3.3125 12.0156 3.3125H12.9531C13.1396 3.3125 13.3184 3.38658 13.4503 3.51844C13.5822 3.6503 13.6562 3.82914 13.6562 4.01562V14.3281C13.6562 14.5146 13.5822 14.6934 13.4503 14.8253C13.3184 14.9572 13.1396 15.0312 12.9531 15.0312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39062 15.031H5.45312C5.26664 15.031 5.0878 14.9569 4.95594 14.8251C4.82408 14.6932 4.75 14.5144 4.75 14.3279V1.67163C4.75 1.48515 4.82408 1.30631 4.95594 1.17445C5.0878 1.04258 5.26664 0.968506 5.45312 0.968506H6.39062C6.5771 0.968506 6.75595 1.04258 6.88781 1.17445C7.01967 1.30631 7.09375 1.48515 7.09375 1.67163V14.3279C7.09375 14.5144 7.01967 14.6932 6.88781 14.8251C6.75595 14.9569 6.5771 15.031 6.39062 15.031Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_475_1070"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0.0625 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartIcon);
export default __webpack_public_path__ + "static/media/ChartIcon.efe20c2f52028aadfae12cb65177958d.svg";
export { ForwardRef as ReactComponent };